import type { TokenAutomation } from "hooks/firestore/models/tokenAutomation";
import type { TokenAllocations } from "@/features/betslip/hooks/useTokenAllocations";

export const byBetslipPriority = (a: TokenAutomation, b: TokenAutomation) =>
  (b?.attributes?.tokenBetSlipPriority ?? 0) -
  (a?.attributes?.tokenBetSlipPriority ?? 0);

export const byAllocationPriority = (
  a: TokenAllocations[number],
  b: TokenAllocations[number],
) => (a.priorityAscending ?? Infinity) - (b.priorityAscending ?? Infinity);
